export default __webpack_public_path__ + "static/media/notFoundError.0367bec4.svg";